import iframeResize from 'iframe-resizer/js/iframeResizer.min.js';

export default defineNuxtPlugin(({ vueApp }) => {
  interface ResizableHTMLElement extends HTMLElement {
    iFrameResizer?: {
      removeListeners: () => void;
    };
  }

  vueApp.directive('resizeIframe', {
    mounted(element, binding) {
      const options = binding.value || {};
      element.addEventListener('load', () => iframeResize(options, element));
    },
    unmounted(element) {
      const resizableEl = element as ResizableHTMLElement;

      if (resizableEl.iFrameResizer) {
        resizableEl.iFrameResizer.removeListeners();
      }
    },
  });
});
